import { Checkbox } from '@repo/go-ui';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import type { AlertsGeneralSettingsStore } from './AlertsGeneralSettingsStore';
import styles from './AlertsScreen.module.scss';

const GRID_DATA_COLS = 1;

const GRID_STYLE = {
  gridTemplateColumns: `280px repeat(${GRID_DATA_COLS}, 130px)`,
};

type Props = {
  store: AlertsGeneralSettingsStore;
};

export const AlertsGeneralTab = observer(function AlertsGeneralTab({ store }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.personalGrid} style={GRID_STYLE}>
      <span className={styles.gridSectionLabel}>{t('settings:Alerts:loggingTitle')}</span>
      <span className={styles.gridColumnHeader}>{t('settings:Alerts:columnAlarmRules')}</span>

      <span className={styles.gridRowLabel}>{t('settings:Alerts:saveToJournal')}</span>
      <div className={styles.gridCell}>
        <Checkbox size="s" checked={store.saveToJournal} onChange={store.setSaveToJournal} />
      </div>
    </div>
  );
});
